import React from 'react';
import { Box, Typography } from '@mui/material';
import { typeMappingHandler } from '../../../constants/keysMapping';
import { TWorkExperience } from '../../../types/User';
import './we.scss';

interface EducationalCardProps {
  workExperience: TWorkExperience;
}

const WorkExperienceCard: React.FC<EducationalCardProps> = (props) => {
  const { workExperience } = props;
  const { jobTitle, companyName, fromMonth, fromYear, toMonth, toYear, itIsMyCurrentJob } =
    workExperience || {};

  return (
    <Box className='mainWorkCard'>
      <Box className='mainContent'>
        <Box className='content'>
          <Typography fontWeight='bold'>{jobTitle}</Typography>

          <Typography color='text.light' fontSize='small'>
            {companyName}
          </Typography>

          <Typography color='text.light' fontSize='small'>
            {`از ${typeMappingHandler(fromMonth).message} ${fromYear} تا ${
              itIsMyCurrentJob ? 'کنون' : `${typeMappingHandler(toMonth).message} ${toYear}`
            }`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default WorkExperienceCard;
